module.exports = __webpack_public_path__ + "static/media/registerBg2.7d505608.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/registerBg2.png
// module id = 1901
// module chunks = 0 1